import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ListActionButtons.css';

type TListActionButtonsProps = {
  isMultiple: boolean;
  isReadButtonDisabled: boolean;
  isPending: boolean;
  isArchive: boolean;
  onArchiveClick(): void;
  onReadClick(): void;
  onRestoreClick(): void;
  onDeleteClick(): void;
};

export const ListActionButtons: React.VFC<TListActionButtonsProps> = ({
  isMultiple,
  isReadButtonDisabled,
  onArchiveClick,
  onDeleteClick,
  onReadClick,
  onRestoreClick,
  isPending,
  isArchive,
}) => {
  return (
    <div className={styles['container']}>
      <Button size="M" theme="fill_white_primary" onClick={onReadClick} disabled={isPending || isReadButtonDisabled}>
        {isMultiple ? 'Прочитать все' : 'Прочитано'}
      </Button>
      {isArchive ? (
        <Button size="M" theme="fill_white_primary" onClick={onRestoreClick} disabled={isPending}>
          {isMultiple ? 'Вернуть все' : 'Вернуть'}
        </Button>
      ) : (
        <Button size="M" theme="fill_white_primary" onClick={onArchiveClick} disabled={isPending}>
          {isMultiple ? 'В архив все' : 'В архив'}
        </Button>
      )}
      <Button size="M" theme="fill_white_primary" onClick={onDeleteClick} disabled={isPending}>
        {isMultiple ? 'Удалить все' : 'Удалить'}
      </Button>
    </div>
  );
};
